import { useLDClient } from 'launchdarkly-react-client-sdk';
import camelCase from 'lodash/camelCase';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Dispatch } from 'src/config/Store';
import { getUser } from 'src/selectors/userSelectors';

export const FeatureFlagsManager: React.FC = () => {
  const ldClient = useLDClient();

  const dispatch = useDispatch<Dispatch>();

  const user = useSelector(getUser);

  const updateFlagsInStore = () => {
    const rawFlags = ldClient?.allFlags() as Record<string, unknown>;

    // transforming `some-feature-flag` to `someFeatureFlag`
    const camelCasedFlags = Object.entries(rawFlags).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [camelCase(key)]: value,
      }),
      {},
    );

    dispatch.featureFlags.saveFlags(camelCasedFlags);
  };

  // here we're saving the flags to the store and start listening for changes to update the store automatically
  // the reason why we're keeping the flags also in the store is to be able to access them in selectors
  // LDClient is not exported statically and can't be accessed outside of the react components without any weird hacks
  useEffect(() => {
    if (ldClient) {
      updateFlagsInStore();

      ldClient.on('change', updateFlagsInStore);
    }
  }, [ldClient]);

  useEffect(() => {
    const currentLdUser = ldClient?.getUser();

    // handles logged in user
    if (!!user?.currentUser?.uuid) {
      const ldUser = {
        key: user.currentUser.uuid,
        country: user.currentUser?.country || '',
      };

      ldClient?.identify(ldUser);
    }

    // handles logout
    if (currentLdUser && !currentLdUser?.anonymous && !user?.currentUser?.uuid) {
      ldClient?.identify({ anonymous: true });
    }
  }, [user, ldClient]);

  return null;
};
